export default __webpack_public_path__ + "static/circle_b.d5ff82e134cdc6d03159b25f4fdea53d.png";